module.exports = __webpack_public_path__ + "img/GIF-FIBRILLARE.5929234c.gif";